import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LOGOS } from "@/lib/utils";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4 animate-pulse">
          <img src={LOGOS.white} alt="Athlynx" className="h-10 w-auto hidden dark:block" />
          <img src={LOGOS.black} alt="Athlynx" className="h-10 w-auto dark:hidden" />
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
